export enum Region {
    Default = 'default',
    Fra = 'fra',
}